import React, { useCallback, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import {
  Box,
  Alert,
  Paper,
  Theme,
  Button,
  SxProps,
  SvgIcon,
  Accordion,
  AlertTitle,
  Typography,
  AccordionDetails,
  AccordionSummary,
} from '@mui/material';

import { ArrowTop, ArrowBottom } from '@/utils/iconSVG';

export const CustomerHolidaysHoursDuringHolidays: React.FunctionComponent<{ sx?: SxProps<Theme> }> = ({ sx }) => {
  const { t } = useTranslation('common');

  const [isAccordionExpanded, setIsAccordionExpanded] = useState(
    localStorage.getItem('isAccordionExpanded') !== null
      ? (JSON.parse(localStorage.getItem('isAccordionExpanded')) as boolean)
      : true,
  );

  const handleExpandAccordion = useCallback(() => {
    setIsAccordionExpanded((prevState) => {
      localStorage.setItem('isAccordionExpanded', String(!prevState));
      return !prevState;
    });
  }, []);
  return (
    <Box component={Paper} elevation={4} sx={{ ...stylesBoxContainer, ...sx } as SxProps}>
      <Alert severity='warning'>
        <AlertTitle>
          <Typography variant='bodyLGBold'>{t('customerHolidaysHoursDuringHolidays.title')}</Typography>
          <Button
            sx={{
              '&:active': {
                backgroundColor: 'transparent',
              },
              '&:hover': {
                backgroundColor: 'transparent',
              },
              '&:focus': {
                outline: 'none',
              },
              '&:focus-visible': {
                outline: 'none',
                boxShadow: 'none',
              },
              '&.Mui-focusVisible': {
                outline: 'none',
                boxShadow: 'none',
              },
            }}
            variant='text'
            color='primary'
            onClick={handleExpandAccordion}
          >
            <SvgIcon component={isAccordionExpanded ? ArrowTop : ArrowBottom} sx={{ height: 20, width: 20 }} />
          </Button>
        </AlertTitle>
        <Accordion expanded={isAccordionExpanded} sx={{ backgroundColor: 'transparent' }}>
          <AccordionSummary sx={{ display: 'none' }} />
          <AccordionDetails sx={{ backgroundColor: 'transparent', border: 'none', p: 0, m: 0 }}>
            <br />
            <Typography variant='bodyLGBold'>{t('customerHolidaysHoursDuringHolidays.content.text1')} </Typography>
            <br />
            <br />
            <Typography variant='bodyLGMedium'>
              <Trans
                i18nKey={t('customerHolidaysHoursDuringHolidays.content.text2')}
                components={{
                  span: <Typography component='span' fontSize='inherit' fontWeight='bold' />,
                }}
              />
            </Typography>
            <br />
            <br />
            <Typography variant='bodyLGMedium'>
              <Trans
                i18nKey={t('customerHolidaysHoursDuringHolidays.content.text3')}
                components={{
                  span: <Typography component='span' fontSize='inherit' fontWeight='bold' />,
                }}
              />
            </Typography>
            <br />
            <br />
          </AccordionDetails>
        </Accordion>
      </Alert>
    </Box>
  );
};
export const stylesBoxContainer = {
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 1.5,
  backgroundColor: '#FFF',
};
